import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_ORDER_INFO } from 'mocks/queries';
import OrderSuccessNew from 'components/consumer/checkout/desktop/components/OrderSuccessNew/OrderSuccessNew';
const OrderSummary = t0 => {
  const $ = _c(16);
  const {
    order_id
  } = t0;
  const [orderInfo, setOrderInfo] = useState(null);
  let t1;
  if ($[0] !== order_id) {
    t1 = {
      order_id
    };
    $[0] = order_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !order_id;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      fetchPolicy: "cache-and-network",
      variables: t1,
      skip: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    loading,
    data,
    error
  } = useSuspenseQuery(GET_ORDER_INFO, t3);
  let t4;
  let t5;
  if ($[5] !== data) {
    t4 = () => {
      if (!data) {
        return;
      }
      const order = data.getOrderInfo?.order || {};
      const orderSummary = {
        grand_total: order.total_order_amount,
        cart_subtotal: order.order_subtotal,
        protectionSubtotal: order.cart_protection_subtotal,
        discount: order.coupon_discount,
        total_shipping: order.addditional_services,
        tax_amount: order.tax_charge,
        gift_used: order.gift_used,
        gift_card_rewards_used: order.gift_card_rewards_used
      };
      let shipping = order.shipping || {};
      shipping = {
        first_name: shipping.address_first_name,
        last_name: shipping.address_last_name,
        address: shipping.address_street1,
        city: shipping.address_city,
        apartment: shipping.apartment,
        company: shipping.address_company,
        state: shipping.address_state,
        zipcode: shipping.address_zip_code,
        phone_number: shipping.address_phone,
        shipping_sms: false
      };
      let payment = {};
      if (order.payment?.[0]?.payment_type === "Credit Card") {
        payment = {
          selected_type: "credit_card",
          split_payment: false,
          credit_cards: order.payment.map(_temp)
        };
      } else {
        if (order.payment?.[0]?.payment_type === "Affirm") {
          payment = {
            selected_type: "affirm"
          };
        } else {
          if (order.payment?.[0]?.payment_type === "Apple Pay") {
            payment = {
              selected_type: "apple_pay"
            };
          } else {
            if (order.payment?.[0]?.payment_type === "PayPal") {
              payment = {
                selected_type: "paypal"
              };
            }
          }
        }
      }
      const cartData = order.order_items?.length ? order.order_items.map(_temp2) : [];
      const groups = groupBy(cartData, "shipping_group");
      const deliveryInfo = {
        production_selection: {},
        production_selection_add: {}
      };
      const shippingGroups = groups ? Object.entries(groups).map(t6 => {
        const [id, group] = t6;
        deliveryInfo.production_selection[id] = {};
        deliveryInfo.production_selection_add[id] = {};
        return {
          id,
          cart: group
        };
      }) : [];
      setOrderInfo({
        orderId: order.order_id,
        orderSummary,
        shipping,
        payment,
        cartData,
        shippingGroups,
        deliveryInfo
      });
    };
    t5 = [data];
    $[5] = data;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  if (error) {
    return `Error!: ${error}`;
  }
  let t6;
  if ($[8] !== loading) {
    t6 = loading ? <div className="text-lg font-bold flex items-center justify-center">Loading..</div> : null;
    $[8] = loading;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== orderInfo || $[11] !== order_id) {
    t7 = orderInfo && <OrderSuccessNew orderId={order_id} orderSummary={orderInfo.orderSummary} shipping={orderInfo.shipping} payment={orderInfo.payment} cartData={orderInfo.cartData} shippingGroups={orderInfo.shippingGroups} deliveryInfo={orderInfo.deliveryInfo} />;
    $[10] = orderInfo;
    $[11] = order_id;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="OrderSummary">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
OrderSummary.propTypes = {
  order_id: PropTypes.string
};
export default OrderSummary;
function _temp(p) {
  return {
    number: p.card_no,
    amount: p.payment_amount
  };
}
function _temp2(item) {
  return {
    ...item,
    id: item.product_id
  };
}